import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { ErrorCapture } from '@/components/Errors/ErrorCapture';
import { ErrorScreen } from '@/components/Errors/ErrorScreen';
import { SupportReportButton } from '@/components/Errors/SupportReportButton';

const ErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ErrorCapture
    fallback={({ error, componentStack }) => (
      <ErrorScreen
        title="Something went wrong"
        message="The application hit an unexpected error and couldn't recover. Reloading usually fixes it; if it keeps happening, report it to support below."
        error={error}
        componentStack={componentStack}
      >
        <Button className="mt-2 w-full" onClick={() => window.location.reload()}>
          Retry
        </Button>
        <div className="mt-3 flex justify-center">
          <SupportReportButton error={error} componentStack={componentStack} />
        </div>
      </ErrorScreen>
    )}
  >
    {children}
  </ErrorCapture>
);

export default ErrorBoundary;
